module.exports = __webpack_public_path__ + "9788f41e/img/saly-icon.39e12342.jpg";